import React from "react";
import emitter from "../Game/Events/EventManager";
import { CHOOSE_TC, CHOOSE_SC, CHOOSE_EN } from "../Game/Events/Events";
import store from "../store/store.jsx";

import { dispatchChangeScene, dispatchChangeLang } from "../Game/reducers/sceneReducer";
export default function Scene1Overlay() {
  function clickLangOption(e, string) {
    dispatchChangeLang(string);
    if (e.keyCode == 13) {
      if (string == "TC") {
        emitter.emit(CHOOSE_TC);

        console.log("Choose TC");
      }

      if (string == "SC") {
        emitter.emit(CHOOSE_SC);
        console.log("Choose SC");
      }

      if (string == "EN") {
        emitter.emit(CHOOSE_EN);
        console.log("Choose EN");
      }
    }
  }

  return (
    <div>
      <div
        tabIndex="1"
        lang={"zh-Hant"}
        onKeyDown={e => {
          clickLangOption(e, "TC");
        }}
      >
        選擇繁體中文
      </div>

      <div
        tabIndex="2"
        lang={"zh-Hans"}
        onKeyDown={e => {
          clickLangOption(e, "SC");
        }}
      >
        選擇簡體中文
      </div>

      <div
        tabIndex="3"
        lang={"en"}
        onKeyDown={e => {
          clickLangOption(e, "EN");
        }}
      >
        Choose English
      </div>
    </div>
  );
}
